import { IconButton, makeStyles } from '@material-ui/core';
import { MdAddCircleOutline } from 'react-icons/md';

const useStyles = makeStyles((theme: any) => ({
    container: {
        cursor: 'pointer',
        marginTop: 10,
        marginBottom: 10,
        borderRadius: 8,
        "& > *": {
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            columnGap: 10,
        },
    },
    icon: {
        color: theme.palette.primary.main,
        height: 23
    },
    title: {
        color: theme.palette.primary.main,
        fontSize: '70%',
        fontWeight: 700
    },
}));

interface Props { 
    title: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const AddItemButton: React.FC<Props> = ({title,onClick}) => {
    const classes = useStyles();

    return (
        <IconButton className={classes.container} onClick={onClick}>
            <MdAddCircleOutline className={classes.icon} />
            <div className={classes.title}>
                {title}
            </div>
        </IconButton>
    );
}


